export default __webpack_public_path__ + "static/card-visa-classic@3x-a04f6dc86b75ebd1672cb0c85677c756.png";